import Slider, { SliderProps } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";

interface PrettoSliderProps extends SliderProps {
  isSmallView: boolean;
}

export const PrettoSlider = styled(
  ({ isSmallView, ...props }: PrettoSliderProps) => <Slider {...props} />
)(({ isSmallView, theme }) => ({
  color: theme.palette.primary.main,
  height: 8,
  width: "70%",
  margin: isSmallView ? "auto" : 0,
  maxWidth: "300px",
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 16,
    width: 16,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 24,
    height: 24,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: theme.palette.primary.main,
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
}));
